import { render, staticRenderFns } from "./unterhaltungsschaden.vue?vue&type=template&id=21747478&scoped=true&"
import script from "./unterhaltungsschaden.vue?vue&type=script&lang=js&"
export * from "./unterhaltungsschaden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21747478",
  null
  
)

export default component.exports